module.exports = __webpack_public_path__ + "img/image-loader.8402b89a.gif";